import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../ThemeContext';
import './Header.css';

const ABOUT_LINKS = [
  // { to: '/comparison-panchayat', label: 'BrahMoID vs My Panchayat App' },
  // { to: '/comparison-ipac', label: 'BrahMoID vs I-PAC' },
  // { to: '/team', label: 'Team' },
];

const PARTNER_LINKS = [
  { to: '/partner/whom-we-serve', label: 'Whom Do We Serve' },
  { to: '/partner/why-adopt', label: 'Why Adopt Us' },
  { to: '/partner/operating-model', label: 'BrahMoID–Party Operating Model' },
  // { to: '/partner/springboard', label: 'Springboard' },
  { to: '/partner/funding', label: 'Our Funding Model' },
  { to: '/partner/contact-form', label: 'Contact Form', subItem: true },
];

const LEADERSHIP_PATHWAYS_LINKS = [
  // { to: '/leadership-pathways/candidate-selection', label: 'Candidate Selection Framework' },
  // { to: '/leadership-pathways/income', label: 'Income' },
  // { to: '/leadership-pathways/progressive-ladder', label: 'Progressive Ladder' },
  // { to: '/leadership-pathways/syllabus', label: 'Syllabus' },
];

const Dropdown = ({ label, links, isActive, onOpen, onClose, isOpen, onNavigate }) => {
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isOpen, onClose]);

  return (
    <div className="nav-dropdown" ref={ref}>
      <button
        type="button"
        className={`nav-dropdown-trigger ${isActive ? 'active' : ''} ${isOpen ? 'open' : ''}`}
        onClick={onOpen}
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        {label}
        <span className="nav-dropdown-chevron" aria-hidden>▼</span>
      </button>
      {isOpen && (
        <ul className="nav-dropdown-menu" role="menu">
          {links.map((link) => {
            const { to, label, subItem } = link;
            return (
              <li key={to} role="none" className={subItem ? 'nav-dropdown-li-subitem' : ''}>
                <Link
                  to={to}
                  className={`nav-dropdown-item ${subItem ? 'nav-dropdown-subitem' : ''}`}
                  role="menuitem"
                  onClick={() => { onClose(); onNavigate?.(); }}
                >
                  {label}
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

const Header = () => {
  const { theme, toggleTheme } = useTheme();
  const location = useLocation();
  const [openDropdown, setOpenDropdown] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // const aboutActive = ABOUT_LINKS.some(({ to }) => location.pathname === to) || location.pathname === '/about'; // for About dropdown when restored
  const partnerActive = PARTNER_LINKS.some((link) => link.to === location.pathname) || location.pathname === '/partner';
  // const leadershipPathwaysActive = LEADERSHIP_PATHWAYS_LINKS.some(({ to }) => location.pathname === to) || location.pathname === '/leadership-pathways'; // for Leadership Pathways dropdown when restored

  const closeAll = () => {
    setOpenDropdown(null);
    setMobileMenuOpen(false);
  };

  useEffect(() => {
    closeAll();
  }, [location.pathname]);

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo" onClick={closeAll}>
          <span className="logo-text">BrahMoID</span>
        </Link>

        <button
          type="button"
          className="header-mobile-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-expanded={mobileMenuOpen}
          aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
        >
          <span className="hamburger-line" />
          <span className="hamburger-line" />
          <span className="hamburger-line" />
        </button>

        <nav className={`nav ${mobileMenuOpen ? 'nav-open' : ''}`} aria-hidden={!mobileMenuOpen}>
          <Link
            to="/"
            className={location.pathname === '/' ? 'active' : ''}
            onClick={closeAll}
          >
            Home
          </Link>
          {/* Single menu item while ABOUT_LINKS are commented out; uncomment Dropdown below and comment this Link to restore list */}
          <Link
            to="/about"
            className={location.pathname === '/about' ? 'active' : ''}
            onClick={closeAll}
          >
            About BrahMoID
          </Link>
          {/* About dropdown – uncomment when ABOUT_LINKS has entries and comment the "About BrahMoID" Link above
          <Dropdown
            label="About BrahMoID"
            links={[{ to: '/about', label: 'About BrahMoID' }, ...ABOUT_LINKS]}
            isActive={aboutActive}
            isOpen={openDropdown === 'about'}
            onOpen={() => setOpenDropdown(openDropdown === 'about' ? null : 'about')}
            onClose={() => setOpenDropdown(null)}
            onNavigate={closeAll}
          />
          */}
          <Dropdown
            label="Partner With Us"
            links={PARTNER_LINKS}
            isActive={partnerActive}
            isOpen={openDropdown === 'partner'}
            onOpen={() => setOpenDropdown(openDropdown === 'partner' ? null : 'partner')}
            onClose={() => setOpenDropdown(null)}
            onNavigate={closeAll}
          />
          {/* Single menu item while LEADERSHIP_PATHWAYS_LINKS are commented out; uncomment Dropdown below and comment this Link to restore list */}
          <Link
            to="/leadership-pathways"
            className={location.pathname.startsWith('/leadership-pathways') ? 'active' : ''}
            onClick={closeAll}
          >
            Leadership Pathways
          </Link>
          {/* Leadership Pathways dropdown – uncomment when LEADERSHIP_PATHWAYS_LINKS has entries and comment the "Leadership Pathways" Link above
          <Dropdown
            label="Leadership Pathways"
            links={LEADERSHIP_PATHWAYS_LINKS}
            isActive={leadershipPathwaysActive}
            isOpen={openDropdown === 'leadership-pathways'}
            onOpen={() => setOpenDropdown(openDropdown === 'leadership-pathways' ? null : 'leadership-pathways')}
            onClose={() => setOpenDropdown(null)}
            onNavigate={closeAll}
          />
          */}
        </nav>
        <button className="theme-toggle" onClick={toggleTheme} aria-label="Toggle theme">
          {theme === 'light' ? '🌙' : '☀️'}
        </button>
      </div>
    </header>
  );
};

export default Header;
